module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/map-japan-84ee5bb8ea8993024b552e6a13791116.png";